import { showError } from '@context/actions';
import Backdrop from '@material-ui/core/Backdrop';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  CloseLargeIcon,
  GlobalPaymentsLogo,
  IconFrame,
  PaystackLogo,
  RazorpayLogo,
  StripeLogo,
} from '@element/icons';
function PaymentVendorModal({ open, handleClose, paymentGatewayList }) {

    const dispatch = useDispatch();
    const [error, seterror] = useState('');
    const [selectedPymode, setSelectedPymode] = useState<any>({})
    const store = useSelector((state: any) => state);
    const languageData: any = store.languageKeywords
    useEffect(() => {
        setSelectedPymode({})
    }, [open])

    const closeModal = () => {
        handleClose(null);
    }

    const onSaveClick = () => {
        if (!Boolean(selectedPymode?.name)) {
            dispatch(showError(`${languageData["Please select paymode vendor"] ? languageData["Please select paymode vendor"] : "Please select paymode vendor"}`))
        } else handleClose(selectedPymode)
    }

    return (
        <div className="address-modal-wrap">
            <Backdrop
                className="backdrop-modal-wrapper"
                open={open ? true : false}
            >
                <div className="backdrop-modal-content"
                    style={{ height: open ? '270px' : '0px' }}
                >
                    <div className="modal-close" onClick={closeModal}>
                        <IconFrame><CloseLargeIcon /></IconFrame>
                    </div>
                    <div className="address-modal">
                        <div className='heading'>{languageData["Select payment vendor"] ? languageData["Select payment vendor"] : "Select payment vendor"}</div>
                        <div className="paymode-list-wrap">
                            {paymentGatewayList?.map((paymode: any, i: number) => {
                                return <div className={`paymode-details-wrap ${paymode.name == selectedPymode.name ? "active" : ""}`} key={i} onClick={() => setSelectedPymode(paymode)}>

                                    {paymode.name == "CCAvenue" && <div className={`paymode-details ${paymode.name}`}>
                                        <img src="https://www.ccavenue.com/images_mcpg/logo.png" />
                                    </div>}

                                    {paymode.name == "Razorpay" && <div className='paymode-details'>
                                        <RazorpayLogo />
                                    </div>}

                                    {paymode.name == "Stripe" && <div className='paymode-details'>
                                        <StripeLogo />
                                    </div>}

                                    {paymode.name == "Paystack" && <div className='paymode-details'>
                                        <PaystackLogo />
                                    </div>}

                                    {(paymode.name === "GlobalPayments" || paymode.name === "Global Payments") && (
                                        <div className='paymode-details'>
                                            <GlobalPaymentsLogo />
                                        </div>
                                    )}
                                </div>
                            })}
                        </div>
                        <div className="save-add-btn">
                            <div className='primary-btn border-btn' onClick={closeModal}>{languageData["Cancel"] ? languageData["Cancel"] : "Cancel"}</div>
                            <div className='primary-btn' onClick={onSaveClick}>{languageData["Continue"] ? languageData["Continue"] : "Continue"}</div>
                        </div>
                    </div>
                </div>
            </Backdrop>
        </div>
    );
}

export default PaymentVendorModal;